import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import VideoCard from '@/components/base/VideoCard';
import { categories } from '@/mocks/data';

interface LatestSectionProps {
  title: string;
  subtitle: string;
  viewAll: string;
}

export default function LatestSection({ title, subtitle, viewAll }: LatestSectionProps) {
  const latestArticles = articles.slice(0, 6);

  const getCategoryName = (slug: string) => {
    return categories.find((c) => c.slug === slug)?.name || slug;
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              {title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              {subtitle}
            </p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            {viewAll}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <VideoCard
              key={article.id}
              title={article.title}
              excerpt={article.excerpt}
              slug={article.slug}
              thumbnail={article.thumbnail}
              category={article.category}
              categoryName={getCategoryName(article.category)}
              views={article.views}
              date={article.date}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors"
          >
            {viewAll}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}